import { createApi } from '@reduxjs/toolkit/query/react';

import { ExtendedProjectTask } from '../taskpane/components/aiChat/components/TaskPicker/types';
import { createBaseQuery } from './api/baseApiConfig';
import config from '../config';

const baseUrl = 'project';

export const TAGS = {
	TASKS: 'TASKS',
	TAGS: 'TAGS',
};

export const projectTaskApi = createApi({
	reducerPath: 'projectTaskApi',
	baseQuery: createBaseQuery(`${config.APIM_BASE_URL}/${baseUrl}`),
	tagTypes: [TAGS.TASKS],
	endpoints: builder => ({
		fetchAllTasks: builder.query<ExtendedProjectTask[], any>({
			query: () => {
				return {
					method: 'GET',
					url: `/tasks`,
				};
			},
			providesTags: [TAGS.TASKS],
		}),
		fetchTaskById: builder.query<ExtendedProjectTask, { taskId: string }>({
			query: ({ taskId }: { taskId: string }) => {
				return {
					method: 'GET',
					url: `/tasks/${taskId}`,
				};
			},
			providesTags: [TAGS.TASKS],
		}),
		fetchAllTasksTags: builder.query({
			query: () => {
				return {
					method: 'GET',
					url: `/tasks/tags`,
				};
			},
			providesTags: [TAGS.TAGS],
		}),
	}),
});

export const { useFetchAllTasksQuery, useFetchAllTasksTagsQuery, useFetchTaskByIdQuery } = projectTaskApi;
